/* ============================================================
 * HighTicketSales.it — Landing "Metodo Nonchalant"
 * BLOCCO DI CONFIGURAZIONE — leggere prima di pubblicare
 * ============================================================
 *
 * PLACEHOLDER RIMASTI DA RIEMPIRE (cerca le [PARENTESI QUADRE] nel sito):
 *   - [URL_VIDEO_LEZIONE]        -> URL embed del video (VSL ancora da registrare)
 *   - [META_PIXEL_ID]            -> ID Meta Pixel (vedi anche public/index.html)
 *   - [FOTO_MENTOR]              -> foto reale di Claudio (ora: asset esistente)
 *   - [FOTO_TESTIMONIAL]         -> foto reali testimonianze (ora: avatar iniziali)
 *   - [SLOT LIBERO]              -> sesta testimonianza futura
 *   - Screenshot commissioni     -> sostituire le card con screenshot reali
 *
 * VARIABILI DI CONFIGURAZIONE (impostare qui sotto):
 *   - FORM_LIVE_ENDPOINT         -> POST iscrizione live  (vuoto = mock localStorage)
 *   - FORM_APPLICATION_ENDPOINT  -> POST candidatura       (vuoto = mock localStorage)
 *   - META_PIXEL_ID / VIDEO_URL / VIDEO_THUMBNAIL / PRIVACY_URL
 *
 * DIMENSIONI ASSET CONSIGLIATE:
 *   - Thumbnail video:        1280 x 720  (16:9)
 *   - Foto mentor:            1000 x 1250 (4:5)
 *   - Foto testimonianze:      400 x 400  (1:1)
 *   - Screenshot commissioni:  900 x 600
 *   - OG image:               1200 x 630
 * ============================================================ */

export const CONFIG = {
  // TODO: inserire l'endpoint reale (es. "/api/live-signup"). Vuoto = salvataggio mock nel browser.
  FORM_LIVE_ENDPOINT: "",
  // TODO: inserire l'endpoint reale (es. "/api/application"). Vuoto = salvataggio mock nel browser.
  FORM_APPLICATION_ENDPOINT: "",

  META_PIXEL_ID: "[META_PIXEL_ID]",

  // VSL ancora da registrare: finche' e' un placeholder tra [ ] il player invita alla live.
  VIDEO_URL: "[URL_VIDEO_LEZIONE]",
  VIDEO_THUMBNAIL:
    "/assets/e3169d1f9f05.webp",
  VSL_COVER:
    "/img/cover-yt9.webp",
  VIDEO_DURATION: "12:04",

  PRIVACY_URL: "#privacy",
};

export const isPlaceholder = (v) => typeof v === "string" && v.trim().startsWith("[");

// Meta Pixel helper — invia l'evento solo se il pixel e' stato inizializzato.
export const trackPixel = (event) => {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", event);
    }
  } catch (e) {
    /* no-op */
  }
};
